<h2 mat-dialog-title>Booking Success</h2>
<mat-dialog-content>
    Booking is Successful. Confirmation Id: <label style="font-weight: bold">{{confirmationId}}</label>
</mat-dialog-content>
<mat-dialog-actions class="actions">
    <button class="btn btn-primary" (click)="refreshPage()">Ok</button>
</mat-dialog-actions>